import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-link-arrow",
  "use": "icon-link-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-link-arrow\"><defs><style></style></defs><path d=\"M231.98 95.52a53.243 53.243 0 1169.003-81.015l532.434 452.356a53.243 53.243 0 010 81.186l-532.434 452.526a53.243 53.243 0 01-69.003-81.1l484.727-411.977L231.98 95.436z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol